import {
  Badge,
  BadgeType,
  ButtonSize,
  IconSize,
  SecondaryButton,
  Spinner,
} from '@lifechurch/react-ion';
import React, { FC, MouseEventHandler } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

export type FetchState = 'idle' | 'loading' | 'error' | 'success';

interface ReinviteButtonProps {
  state: FetchState;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const ReinviteButton: FC<ReinviteButtonProps> = ({ state, onClick }) => {
  const { t } = useTranslation('common');
  const theme = useTheme();
  switch (state) {
    case 'error': {
      return <Badge type={BadgeType.ERROR}>Error: Try Again</Badge>;
    }
    case 'loading': {
      return (
        <SecondaryButton size={ButtonSize.XS} px={7} disabled>
          <Spinner size={IconSize.SM} color={theme.colors.gray50} />
        </SecondaryButton>
      );
    }
    case 'idle': {
      return (
        <SecondaryButton size={ButtonSize.XS} onClick={onClick}>
          {t('resend_invite')}
        </SecondaryButton>
      );
    }
    case 'success': {
      return <Badge type={BadgeType.SUCCESS}>Invite Sent</Badge>;
    }
  }
};
